import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

// Connects to data-controller="tom-select"
export default class extends Controller {
  connect() {
    let settings = {
      maxOptions: null,
    };
    if (this.element.getAttribute("multiple") == "multiple") {
      settings["plugins"] = ["remove_button"];
      settings["hidePlaceholder"] =
        this.element.dataset.hidePlaceholder == "true" ? true : false;
    }
    new TomSelect(this.element, settings);
  }
}
